import './stock-alert.scss'
import axios from "axios"
import ApiService from "@bodeboca/api"
import {useEffect, useState} from "react"
import classNames from 'classnames'
import CommonUtils from "@bodeboca/utils"

const StockAlert = ({ product, userFlaggedItems, availableBundlesToFlag }) => {


  let apiFlagPath = ApiService.getPrefixedUrl('api/v4/flags/stock')
  const brandFlag = 'brand'
  const spiritFlag = 'product'
  const [isFlagged, setIsFlagged] = useState(isFlaggedItem)

  const unsubscribedButtonStyles = {
    backgroundImage: 'url(/themes/custom/bodeboca/fonts/svg/stock-alert-bell.svg)',
    backgroundRepeat: 'no-repeat',
    backgroundSize: '18px 17px'
  }

  const buttonText = isFlagged ? Drupal.t("I'm no longer interested") : Drupal.t("Let me know")

  useEffect(() => {
    setIsFlagged(isFlaggedItem)
  }, [userFlaggedItems, product])

  function isFlaggedItem() {

    let flaggedItems = userFlaggedItems

    if (flaggedItems !== undefined && flaggedItems !== null) {
      const flagType = getFlagType()

      if (!flaggedItems[flagType]) {
        return false
      }
      flaggedItems = flaggedItems[flagType]

      if (flagType === brandFlag) {
        // todo: do not search by name when we have brand_id in Algolia
        return flaggedItems.some(item => item.name === product.brand)
      }

      return flaggedItems.includes(product.product_id.toString())
    }

    return false
  }

  /**
   * Gets the type of flag depending on the type of product.
   *
   * @returns {number}
   *   The flag type (product or brand).
   */
  function getFlagType() {

    if (!isFlaggable()) {
      throw new Error("The product type " + product.node_type + " is not supported")
    }

    if (product.node_type === 'spirit') {
      return spiritFlag
    }

    return brandFlag
  }

  function isFlaggable(): boolean {

    return (
      availableBundlesToFlag.includes(product.node_type) &&
      product.hasOwnProperty('brand') &&
      product.brand !== ''
    )
  }

  function buildUrl(productId) {

    if (productId === '') {
      throw new Error("The product ID is required to build the URL for stock alerts.")
    }

    return apiFlagPath + '/' + getFlagType() + '/' + productId + '/subscribe'
  }

  function toggleSubscribe() {

    toggle().then(() => {
      CommonUtils.setIsLoading(false)
      if (!isFlagged) {
        showStockAlertMessage()
      }
      setIsFlagged(!isFlagged)
    })
  }

  function showStockAlertMessage() {

    let message = Drupal.t('Great choice! We will let you know when this or a later vintage is available.')
    if (getFlagType() === spiritFlag) {
      message = Drupal.t('Great choice! We will let you know when this product is available.')
    }

    CommonUtils.showBbAjaxMessage(message, 'notice')
  }

  const toggle = async () => {

    CommonUtils.setIsLoading(true)
    const csrfToken = await ApiService.getCsrfToken()

    const config = {
      method : isFlagged ? 'DELETE' : 'POST',
      url : buildUrl(product.product_id),
      data : null,
      headers: {
        'Content-Type': 'application/json',
        'X-CSRF-Token' : csrfToken
      }
    }

    return new Promise((resolve, reject) => {
      axios(config)
        .then((response) => {
          ApiService.setUserFlaggedStockItems(response.data)
          resolve()
        })
        .catch((err) => {
          CommonUtils.setIsLoading(false)
          CommonUtils.showBbAjaxMessage(
            Drupal.t('We are having some problems. Please try again later.'),
            'error'
          )
          reject()
        })
    })
  }

  return (ApiService.getUserId() !== 0 &&
    <div
      className="bb-button brandonbutton flag action-flag"
      onClick={() => toggleSubscribe()}>
      <a
        className={classNames('use-ajax aflag', { flagged : isFlagged, unflagged : !isFlagged })}
        data-once="ajax throbber-bb"
        rel="nofollow"
        style={!isFlagged ? unsubscribedButtonStyles : {}}
        title={buttonText}>
        { buttonText }
      </a>
    </div>
  )

}

export default StockAlert
